module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('add-item-component', {
    attrs: {
      "id": _vm.id
    },
    on: {
      "add": _vm.addItem
    }
  }), _vm._v(" "), _c('items-component', {
    attrs: {
      "items": _vm.items,
      "id": _vm.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('hr'), _vm._v(" "), _c('change-title-component', {
    attrs: {
      "title": _vm.title,
      "id": _vm.id
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5460a3a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShoppingListComponent.vue
// module id = 56
// module chunks = 1